<template>
    <div class="statistic__row" v-if="botStatInfo.as_checks.length">
        <div class="statistic__row__time" @click="openBotStat" :style="colorPercent()">
            <p>{{parseDate(botStatInfo.datetime)}}</p>
            <span>-</span>
            <p>{{parseDate(botStatInfo.datetime, true)}}</p>
                <span class="count">{{botStatInfo.as_checks.length}} (пр.)</span>
            <img :class="{ rotate: open }" src="../../assets/images/down-arrow.svg" alt="open">
        </div>
        <div class="statistic__information" v-show="open">
            <div class="statistic__row__info" v-for="botInfo in botStatInfo.as_checks">
                <p>{{botInfo.bot_id}}</p>
                <span>-</span>
                <p v-for="(verdict, key) in botInfo.verdicts" :class="{'problemBot': key !== '1' && key !== '5'}">
                    {{verdictTypes[key - 1]}} ({{verdict}})
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"BotStatistic",
    props: ["botStatInfo"],
    data () {
        return {
            open: false,
            verdictTypes: ['Скамеров не было', 'Был 1 скамер', 'Было несколько скамеров', 'Не удалось зайти к боту',
                'Не было проблем', 'Бота не было на месте', 'Бот не принимает заявку в друзья', 'У бота много друзей',
                'Нет профиля бота по ссылке', 'Бота нет в игре'
            ],
        }
    },
    methods: {
        parseDate(time, end) {
            const d = new Date(time);

            d.setMinutes(d.getMinutes() + -d.getTimezoneOffset());

            if (end) {
                d.setHours(d.getHours() + 1)
                return d.toLocaleString("ru-RU", {
                    hour: "numeric",
                    minute: "numeric"
                });
            }

            return d.toLocaleString("ru-RU", {
                timeZone: "Europe/Moscow",
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
            });
        },
        openBotStat () {
            this.open = !this.open
        },
        colorPercent () {
            let problemBots = 0
            for (const bot of this.botStatInfo.as_checks) {
                for (const key in bot.verdicts) {
                    if (key !== '1' && key !=='5') {
                        problemBots += 1
                        break;
                    }
                }
            }
            const percent = (problemBots * 100)/this.botStatInfo.as_checks.length
            return `border-color: rgb(255, ${255 - (percent*255)/100}, ${255 - (percent*255)/100})`
        }
    },
}
</script>
